import { render, staticRenderFns } from "./CallAddTasks.vue?vue&type=template&id=3facbadd"
import script from "./CallAddTasks.vue?vue&type=script&lang=js"
export * from "./CallAddTasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports